import {
  faFile,
  faFileImage,
  faFilePdf,
  faFileText,
  faFileWord,
  faFileXls,
  type IconDefinition
} from '@fortawesome/pro-solid-svg-icons'
import type { AttachmentFormat, AttachmentFormatInfo } from '../types'

const FORMAT_MAPPINGS: Record<string, AttachmentFormat> = {
  // PDF
  pdf: 'pdf',

  // Images
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
  gif: 'image',
  bmp: 'image',
  tiff: 'image',
  tif: 'image',
  webp: 'image',
  svg: 'image',

  // Documents
  doc: 'document',
  docx: 'document',
  odt: 'document',
  rtf: 'document',
  xls: 'sheet',
  xlsx: 'sheet',

  // Text
  txt: 'text',

  // HTML
  html: 'html',
  htm: 'html'
}

function getFileExtension(filename: string): string {
  const extension = filename.split('.').pop()?.toLowerCase()
  return extension || ''
}

function getIcon(format: AttachmentFormat): IconDefinition {
  switch (format) {
    case 'pdf':
      return faFilePdf
    case 'image':
      return faFileImage
    case 'document':
      return faFileWord
    case 'sheet':
      return faFileXls
    case 'html':
      return faFileText
    case 'text':
      return faFileText
  }

  return faFile
}

export function detectAttachmentFormat(filename: string): AttachmentFormatInfo {
  const extension = getFileExtension(filename)
  const format = FORMAT_MAPPINGS[extension] || 'unsupported'

  return {
    format,
    supportsZoom: format === 'pdf',
    extension,
    icon: getIcon(format)
  }
}
